const { findIndex } = require('lodash');

class FulfilmentTimetableController {
    constructor($filter, moveFocus, addressService, shopperService, settings, deliverySaverConstants, userPreferenceService) {
        this.$filter = $filter;
        this.moveFocus = moveFocus;
        this.addressService = addressService;
        this.shopperService = shopperService;
        this.settings = settings;
        this.deliverySaverConstants = deliverySaverConstants;
        this.userPreferenceService = userPreferenceService;
    }

    $onInit() {
        this.initialize();
        this.moveFocus('#fulfilmentTimetable');
    }

    $onChanges(changed) {
        if (changed.timeTable) {
            this.selectFirstAvailableDate();
        }
    }

    getFulfilmentMethod() {
        return this.isDelivery ? 'delivery' : this.settings.fulfilmentMethod.timetablePickupName;
    }

    initialize() {
        this.availableTimes = this.availableTimes || [];

        if (this.reservedDate) {
            this.savedTime = {
                time: this.reservedTime,
                date: this.reservedDate,
            };
        }

        this.IsExpressDeliveryUnavailable = false;
        this.expressDeliveryUnavailableMessage = '';
        this.hasDismissedDeliveryPlusSuspendedNotification = false;
        this.hasDismissedDeliveryPlusDayOfWeekNotification = false;
        this.hasDismissedDeliveryPlusSameDayNotification = false;
        this.hasDismissedDeliveryPlusOptOutNotification = false;
        this.deliveryPlusCancelledNotificationDisabled = false;

        const deliveryPlusSubscriptionEndingDate = this.$filter('date')(this.shopperService.shopper.DeliveryPlusSubscriptionEndingDate, 'd MMMM, yyyy');
        this.optOutNotificationText = this.settings.deliverySaver.optOutNotificationText.replace('{{ EndDate }}', deliveryPlusSubscriptionEndingDate);
        this.cancelledNotificationText = this.settings.deliverySaver.cancelledNotificationText.replace('{{ DiscoverPageUrl }}', this.settings.deliverySaver.discoverPageUrl);

        this.userPreferenceService.getUserPreference().then((result) => {
            // only show delivery plus cancelled notification once
            this.deliveryPlusCancelledNotificationDisabled = result.DeliveryPlusCancelledNotificationDisabled;
            if (this.shouldShowDeliveryPlusCancelledNotification()) {
                this.userPreferenceService.SetDeliveryPlusCancelledNotificationDisabled(true);
            }
        });
    }

    selectFirstAvailableDate() {
        if (this.timeTable && this.timeTable.length > 0) {
            this.initialize();

            // get index of first available date
            let index = (this.savedDate && this.savedDeliveryWindowId)
                ? findIndex(this.timeTable, deliveryWindow => deliveryWindow.Date.substring(0, 11) === this.savedDate.substring(0, 11))
                : findIndex(this.timeTable, date => date.Available);

            // _.findIndex will return -1 if the date list is unretrievable.
            // This will set index to 0 if no dates are available.
            index = index > 0 ? index : 0;

            // set focus on the first available date or first item
            this.moveFocus('.fulfilmentTimetable-timeSelectorItem.available:first');

            this.selectedDate = this.timeTable[index];
            this.availableTimes = this.selectedDate.Times;

            this.IsExpressDeliveryUnavailable = this.selectedDate.IsExpressDeliveryExhausted;
            this.expressDeliveryUnavailableMessage = this.selectedDate.ExpressWindowClosedText;
        }
    }

    saveSelectedDate(selectedDate) {
        if (this.onSetFulfilmentDate) {
            this.onSetFulfilmentDate({ selectedDate });
        }
        this.selectedDate = selectedDate;
        this.availableTimes = this.selectedDate.Times;
    }


    setDate(selectedDate) {
        this.selectedDate = selectedDate;
        this.availableTimes = this.selectedDate.Times;

        this.moveFocus(this.selectedDate.Available
            ? '#fulfilmentTimetableTime'
            : '.fulfilmentTimetable ._no-window');
    }

    setTime(fulfilmentTime) {
        this.saveSelectedDate(this.selectedDate);
        this.selectedTime = fulfilmentTime;

        if (this.onSetFulfilmentTime) {
            this.onSetFulfilmentTime({ fulfilmentTime });
        }
    }

    screenReaderLabelForDeliveryTime(fulfilmentTime) {
        let labelTxt = `${fulfilmentTime.TimeWindow}.`;
        let priceTxt = '';
        const isSelectedDateEligibleForDeliverySaver = this.selectedDate && this.selectedDate.EligibleForDeliverySaver;
        if (!isSelectedDateEligibleForDeliverySaver && fulfilmentTime.Price !== undefined) {

            if (!(fulfilmentTime.Price > 0) && !(this.selectedDate && this.selectedDate.DeliveryPlus.IsEligible)) {
                priceTxt = ' free';
            } else {
                const isDiscountedPrice = fulfilmentTime.SalePrice < fulfilmentTime.Price;
                if (isDiscountedPrice) {
                    priceTxt = ` Was $${fulfilmentTime.Price} now $${fulfilmentTime.SalePrice}`;
                } else {
                    priceTxt = ` $${fulfilmentTime.Price}`;
                }
            }

        } else {
            priceTxt = ' free';
        }

        if (fulfilmentTime.IsKeptOpenForRewardsPlus) {
            labelTxt = `${labelTxt}${priceTxt}. Was ${fulfilmentTime.NormalAllocationStatus}, `;
            labelTxt = `${labelTxt}${this.settings.delivery.deliveryWindowReservedMessage}. `;
        } else {
            labelTxt = `${labelTxt}${priceTxt}. ${fulfilmentTime.Status}`;
        }

        if (this.selectedTime === fulfilmentTime) {
            labelTxt += ' selected';
        }

        const needToConfirmReminder = 'Press enter to confirm your selection.';
        if (fulfilmentTime.Status !== 'Closed') {
            labelTxt += needToConfirmReminder;
        }
        return labelTxt;
    }

    moveFocusToFirstTimeslot() {
        if (this.availableTimes.length > 0) {
            this.moveFocus(`#${this.availableTimes[0].Id}`);
        }
    }

    hasTimetable() {
        return this.timeTable && this.timeTable.length > 0;
    }

    shouldShowDeliveryPlusSuspendedNotification() {
        return this.hasTimetable()
            && this.isDelivery
            && this.shopperService.shopper.DeliveryPlusSubscriptionStatus === this.deliverySaverConstants.SUBSCRIPTION_STATUS.SUSPENDED
            && !this.hasDismissedDeliveryPlusSuspendedNotification;
    }

    shouldShowDeliveryPlusDayOfWeekNotification() {
        return this.hasTimetable()
            && this.shopperService.shopper.DeliveryPlusSubscriptionStatus === this.deliverySaverConstants.SUBSCRIPTION_STATUS.ACTIVE
            && this.selectedDate
            && this.selectedDate.DeliveryPlus.IsIneligibleBecauseDayOfWeek
            && !this.hasDismissedDeliveryPlusDayOfWeekNotification;
    }

    shouldShowDeliveryPlusSameDayNotification() {
        return this.hasTimetable()
            && this.shopperService.shopper.DeliveryPlusSubscriptionStatus === this.deliverySaverConstants.SUBSCRIPTION_STATUS.ACTIVE
            && this.selectedDate
            && this.selectedDate.DeliveryPlus.IsIneligibleBecauseSameDay
            && !this.selectedDate.DeliveryPlus.IsIneligibleBecauseDayOfWeek
            && !this.hasDismissedDeliveryPlusSameDayNotification;
    }

    shouldShowDeliveryPlusOptOutNotification() {
        return this.shopperService.shopper.DeliveryPlusSubscriptionStatus === this.deliverySaverConstants.SUBSCRIPTION_STATUS.ACTIVE
            && this.shopperService.shopper.DeliveryPlusSubscriptionEndingDate
            && !this.hasDismissedDeliveryPlusOptOutNotification;
    }

    shouldShowDeliveryPlusCancelledNotification() {
        return this.shopperService.shopper.DeliveryPlusSubscriptionStatus === this.deliverySaverConstants.SUBSCRIPTION_STATUS.CANCELLED
            && !this.deliveryPlusCancelledNotificationDisabled;
    }

    onDismissDeliveryPlusSuspendedNotification() {
        this.hasDismissedDeliveryPlusSuspendedNotification = true;
    }

    onDismissDeliveryPlusDayOfWeekNotification() {
        this.hasDismissedDeliveryPlusDayOfWeekNotification = true;
    }

    onDismissDeliveryPlusSameDayNotification() {
        this.hasDismissedDeliveryPlusSameDayNotification = true;
    }

    onDismissDeliveryPlusOptOutNotification() {
        this.hasDismissedDeliveryPlusOptOutNotification = true;
    }
}

FulfilmentTimetableController.$inject = ['$filter', 'MoveFocus', 'AddressService', 'ShopperService', 'Settings', 'DeliverySaverConstants', 'UserPreferenceService'];

const fulfilmentTimetableComponentDefinition = {
    bindings: {
        timeTable: '<',
        reservedDate: '<',
        reservedTime: '<',
        onSetFulfilmentDate: '&?',
        onSetFulfilmentTime: '&?',
        savedDate: '@',
        savedDeliveryWindowId: '@',
        isDelivery: '<',
    },
    controller: FulfilmentTimetableController,
    template: require('./fulfilment-timetable.component.html').trim(),
};

module.exports = {
    FulfilmentTimetableController,
    fulfilmentTimetableComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/timeslots/fulfilment-timetable.component.js